import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PageHeadingComponent } from "./page-heading/page-heading.component";
import { PresetSelectionComponent } from "./preset-selection/preset-selection.component";
import { SavePresetDialogComponent } from "./save-preset-dialog/save-preset-dialog.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatDividerModule } from "@angular/material/divider";
import { MatMenuModule } from "@angular/material/menu";
import { MatDialogModule } from "@angular/material/dialog";
import { FuseModule } from "@fuse";
import { MatButtonModule } from "@angular/material/button";
import { RequestListComponent } from "./request-list/request-list.component";
import { ExcelModule, GridModule } from "@progress/kendo-angular-grid";
import { DirectivesModule } from "app/core/directives/directives.module";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { FormListComponent } from "./form-list/form-list.component";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { LabelModule } from "@progress/kendo-angular-label";
import { RouterModule } from "@angular/router";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { LeftVerticalNavigationComponent } from "./left-vertical-navigation/left-vertical-navigation.component";
import { FuseNavigationModule } from "@fuse/components/navigation";
import { JsonObjectInputComponent } from "./json-object-input/json-object-input.component";
import { MatTableModule } from "@angular/material/table";
import { FormVersionHistoryDialogComponent } from "./form-version-history-dialog/form-version-history-dialog.component";
import { DeleteFormDialogComponent } from './delete-form-dialog/delete-form-dialog.component';
import { UnpublishFormDialogComponent } from './unpublish-form-dialog/unpublish-form-dialog.component';
import { ConfirmationDialogueComponent } from "./confirmation-dialogue/confirmation-dialogue.component";

@NgModule({
    declarations: [
        PageHeadingComponent,
        PresetSelectionComponent,
        SavePresetDialogComponent,
        RequestListComponent,
        FormListComponent,
        LeftVerticalNavigationComponent,
        JsonObjectInputComponent,
        FormVersionHistoryDialogComponent,
        DeleteFormDialogComponent,
        UnpublishFormDialogComponent,
        ConfirmationDialogueComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatSelectModule,
        MatDividerModule,
        MatMenuModule,
        MatDialogModule,
        // FuseModule,
        MatButtonModule,
        MatAutocompleteModule,
        MatTableModule,

        // Kendo Modules
        GridModule,
        ButtonsModule,
        DropDownsModule,
        InputsModule,
        LabelModule,
        ExcelModule,

        // Custom Directives
        DirectivesModule,

        FuseNavigationModule,
    ],
    exports: [
        PageHeadingComponent,
        PresetSelectionComponent,
        RequestListComponent,
        FormListComponent,
        DirectivesModule,
        LeftVerticalNavigationComponent,
        JsonObjectInputComponent,
        LabelModule,
    ],
})
export class SharedModule { }
